import { createUseStyles } from 'react-jss'

import { COLOR, MQ } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    background: COLOR.OFF_WHITE,
  },
  container: {
    width: '80%',
    maxWidth: 325,
    margin: 'auto',
    padding: [60, 0, 0],
    [MQ.TABLET]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      maxWidth: 1150,
      width: '81.5%',
      padding: [100, 0, 0],
    },
    [MQ.DESKTOP]: {
      width: '73.75%',
      padding: [140, 0, 0],
    },
  },
  tallText: {
    [MQ.TABLET]: {
      alignItems: 'flex-start',
    },
  },
  flip: {
    [MQ.TABLET]: {
      flexDirection: 'row-reverse',
    },
  },
  image: {
    [MQ.TABLET]: {
      width: '47.5%',
    },
    '& div': {
      borderRadius: 20,
    },
  },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    [MQ.TABLET]: {
      width: '48%',
    },
  },
  title: {
    margin: [28, 0, 0],
    color: COLOR.DARK_GREEN,
    [MQ.TABLET]: {
      margin: 0,
    },
    [MQ.DESKTOP]: {
      width: '80%',
    },
  },
  body: {
    margin: [28, 0, 0],
    color: COLOR.DARK_GREEN,
  },
  button: {
    margin: [28, 0, 0],
  },
})
